import React from 'react';
import Box from '@mui/material/Box';

import PaymentBrandContent from './components/PaymentBrandContent';

const currencyMapper = {
  usd: '$',
  gbp: '£',
};

const buildDonationAmountContent = (currency, cents) =>
  `${currencyMapper[currency.toLowerCase()]}${Number.parseFloat(
    cents / 100,
  ).toFixed(2)}`;

const convertDateString = (value) => {
  const date = new Date(value);
  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'long',
    timeStyle: 'short',
  }).format(date);
};

export const usePaymentInfoRows = ({
  amount_cents,
  paid_at,
  currency,
  status,
  stripe_card_brand,
  stripe_card_last4,
}) => {
  const rows = [
    {
      title: 'Amount',
      content: buildDonationAmountContent(currency, amount_cents),
    },
    {
      title: 'Status',
      content: <Box sx={{ textTransform: 'capitalize' }}>{status}</Box>,
    },
    {
      title: 'Payment',
      content: (
        <PaymentBrandContent
          brand={stripe_card_brand}
          lastDigits={stripe_card_last4}
        />
      ),
    },
  ];

  if (paid_at) {
    rows.push({
      title: 'Date',
      content: convertDateString(paid_at),
    });
  }

  return rows;
};
